import styled from 'styled-components';
export const MaxContentWrapper = styled.div `
  width: 100%;
  max-width: 148.4rem;

  ${({ theme }) => theme.media.tabletL `
    margin: 0 auto;
    padding: 0 2.2rem;
`}
`;
//# sourceMappingURL=MaxContentWrapper.js.map